import React, {Component} from 'react';
import strings from '../../strings';

import './styles.scss';

class AdminReadyButton extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const {
			remoteIsReady,
			isPractiseTasks,
			testKeyType = null,
			onClick,
		} = this.props;


		const buttonText = isPractiseTasks
			? strings.startPracticeTasks
			: strings.starttest;

		const isAdultFollowup = testKeyType === 'adult-followup';

		const waitingText = isAdultFollowup
			? strings.waitingForCandidate_adult
			: strings.waitingForCandidate;

		return (
			<div className="AdminReadyButton">
				<button
					className="AdminReadyButton__button"
					disabled={!remoteIsReady}
					onClick={onClick}
				>
					{buttonText}
				</button>

				{!remoteIsReady && (
					<p className="AdminReadyButton__label">{waitingText}</p>
				)}
			</div>
		);
	}
}

export default AdminReadyButton;
